import { render, staticRenderFns } from "./SensorLastReception.vue?vue&type=template&id=53559e5d&"
import script from "./SensorLastReception.vue?vue&type=script&lang=js&"
export * from "./SensorLastReception.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SensorLastReception.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53559e5d')) {
      api.createRecord('53559e5d', component.options)
    } else {
      api.reload('53559e5d', component.options)
    }
    module.hot.accept("./SensorLastReception.vue?vue&type=template&id=53559e5d&", function () {
      api.rerender('53559e5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/SensorLastReception.vue"
export default component.exports